// Conversão entre o canvas 2D (Konva) e as coordenadas do Meep.
// Canvas: pixels, origem no canto superior esquerdo, y para baixo.
// Meep: µm, origem no centro da célula, y para cima.

export const canvasToMeep = (state, x, y) => [
  (x / state.dimensions.relationship.x) - (state.coordinates.x / 2),
  (state.coordinates.y / 2) - (y / state.dimensions.relationship.y)
];

export const meepToCanvas = (state, x, y) => [
  (x + state.coordinates.x / 2) * state.dimensions.relationship.x,
  (state.coordinates.y / 2 - y) * state.dimensions.relationship.y
];

// Frequência do Meep (c/µm) a partir do comprimento de onda em µm, e vice-versa
export const wavelengthToFrequency = (wavelength) => (wavelength > 0 ? 1 / wavelength : 0);
export const frequencyToWavelength = (frequency) => (frequency > 0 ? 1 / frequency : 0);
